
function RemoteRequest()
{
	if (typeof XMLHttpRequest !== "undefined") {
		this.http = new XMLHttpRequest();
  } else if (typeof ActiveXObject !== "undefined") {
  	this.http = new ActiveXObject("MSXML2.XmlHttp");
  } else {
  	this.http = null;
  }
}

RemoteRequest.prototype.requestData = function(url, page, marker, callback)
{
	if (this.http === null)
		return;
		
	if (this.http.readyState !== 0)	
  	this.http.abort();

  this.http.onreadystatechange = function() {
  	try {
	  	if (this.http.readyState === 4) {
	  		if (this.http.status === 200) {
	  			callback(this.http.responseText);
	  		}
	  	}
	  }
	  catch(e) {
	  }
  }.bind(this);

  this.http.open("GET", url, true);
  this.http.setRequestHeader('X-SUNFLOWER-PAGE', page.toString());
  this.http.setRequestHeader('X-SUNFLOWER-MARKER', marker);
  this.http.send(null);
};


